import Vue from 'vue'

import '../assets/scss/bootstrap.scss'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)
